import { TSFontSpecs } from "react-native-text-size";

/*
 ** To calculate line count precisely, we must add letterSpacing to each character, except the last one on each line.
 ** To do so, we add (letterSpacing * stringToMeasure.length - 1) to each `wordWidth` (to see if it fits on the line), then we add a last `letterSpacing` if we stay on the first line.
 */
export const getTextLineCount = (text: string, maxWidth: number, style: TSFontSpecs) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.font = `${style.fontWeight || "normal"} ${style.fontSize}px ${style.fontFamily}`;

    const letterSpacing = style.letterSpacing || 0;

    const words = text.split(" ");
    let lineCount = 1;
    let currentLineWidth = 0;

    words.forEach((word, index) => {
        const stringToMeasure = `${index === 0 ? "" : " "}${word}`;

        const wordWidth =
            ctx.measureText(stringToMeasure).width + letterSpacing * (stringToMeasure.length - 1);

        if (currentLineWidth + wordWidth > maxWidth) {
            lineCount++;
            currentLineWidth = wordWidth;
        } else {
            currentLineWidth += wordWidth + letterSpacing;
        }
    });

    return lineCount;
};
